/**
 * @fileoverview パスワード更新API
 *
 * このファイルでは、認証済みユーザーが自分のパスワードを
 * 更新するためのAPI連携機能を提供します。
 */

/**
 * ユーザーのパスワードを更新する
 *
 * 現在のパスワードを確認した上で、新しいパスワードをシステムに登録します。
 * セキュリティ上の理由から、現在のパスワードの検証が必要です。
 * この関数は認証済みユーザーの自発的なパスワード変更に使用されます。
 *
 * @param {string} currentPassword - 現在のパスワード（確認用）
 * @param {string} newPassword - 設定する新しいパスワード
 * @param {string} [csrfToken] - CSRF保護のためのトークン
 * @returns {Promise<void>} パスワード更新成功を示すPromise
 * @throws {Error} パスワード更新失敗やAPI通信エラーが発生した場合
 */
import { fetchWithLog } from "./_fetchWithLog";

export const updatePassword = async (
  currentPassword: string,
  newPassword: string,
  csrfToken: string
) => {
  const bffOrigin = import.meta.env.VITE_BFF_ORIGIN;
  const res = await fetchWithLog(`${bffOrigin}/v1/password/change`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      current_password: currentPassword,
      new_password: newPassword,
      csrf_token: csrfToken,
    }),
    cache: "no-cache",
    credentials: "include",
  });

  if (!res.ok) {
    console.error("Failed to update password.");
    throw new Error("Failed to update password.");
  }
};
